var constants = {
    DATE_SHORT_MONTH_FORMAT: 'MMM D, YYYY',
};

export { constants };
